<div class="modal-title">Select an instrument</div>

<dropdown type="light" [value]="getSelectedInstrument()" [showTooltip]="false" [items]="getInstrumentsList()" (selectedItem)="selectInstrument($event)"></dropdown>

<div class="button-container">
    <a-button label="Get data for instrument" type="secondary" width="100%" (onClick)="autoFillData()" *ngIf="!isLoading"></a-button>

    <div class="loader" *ngIf="isLoading"></div>
</div>